// --- React & Redux
import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
// --- Actions & Hooks
import { useProductsActions } from 'datastage/store/products/useProducts';
// --- External UI Libraries
import { Drawer } from 'antd';
// --- Components
import { TabsContent } from './tabs';
// --- Styles
import './styles.scss';

/**
 * Product Details Drawer
 *
 * Features:
 * - Displays a drawer with detailed information about a selected product
 * - Integrates with Redux for state management
 * - Utilizes TabsContent component to show various details
 * - Read-only view (no refresh needed on close)
 *
 * @returns {JSX.Element}
 */
export const ProductDetailsDrawer = () => {
    const { isDetailsOpen, details } = useSelector((state) => state.products);
    const { updateProducts } = useProductsActions();

    // Close the drawer (no refresh needed for read-only details view)
    const handleClose = useCallback(() => {
        updateProducts({ isDetailsOpen: false });
    }, [updateProducts]);

    return (
        <Drawer
            className="products-details-drawer"
            title="Product Details"
            width={800}
            placement="right"
            open={isDetailsOpen}
            onClose={handleClose}
            bodyStyle={{ paddingBottom: 80 }}
        >
            <TabsContent details={details} />
        </Drawer>
    );
};
